import React, { useEffect, useState } from 'react';
import { Ad } from 'modules/ads';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  slot300: {
    minWidth: 300,
    minHeight: 250,
    background: theme.palette.paperColor,
  },
}));

const RightColumn = (props) => {
  const classes = useStyles();
  const [scrollable, setScrollable] = useState(false);
  const listenScrollEvent = (e) => {
    if (window.scrollY > 260) {
      setScrollable(true);
    } else {
      setScrollable(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', listenScrollEvent);
  });

  return (
    <Grid container direction="column">
      <div
        style={
          scrollable
            ? { position: 'fixed', marginTop: 0 }
            : { position: 'fixed', marginTop: 0 }
        }
      >
        <Ad
          className={classes.slot300}
          noReport={true}
          adContainer="advert_right_col_1"
          slotName="sticky_ad_1"
          adName="sticky_ad_main_1"
          divId={'div-gpt-ad-1480546641062-0'}
          showAdMessage={true}
        />
      </div>
      <div
        style={
          scrollable
            ? { position: 'fixed', marginTop: 260 }
            : { position: 'fixed', marginTop: 260 }
        }
      >
        <Ad
          className={classes.slot300}
          noReport={true}
          adContainer="advert_right_col_2"
          slotName="sticky_ad_2"
          adName="sticky_ad_main_2"
          divId={'div-gpt-ad-1516300497271-0'}
          showAdMessage={true}
        />
      </div>
    </Grid>
  );
};

export default RightColumn;
